"use strict";

exports.__esModule = true;
exports.getRealShape = exports.default = void 0;

var _react = require("react");

const getCSSStyleVal = (str, parentNum) => {
  if (!str) return 0;
  const strVal = str.includes('px') ? +str.split('px')[0] : str.includes('%') ? +str.split('%')[0] * parentNum * 0.01 : str;
  return Number.isNaN(+strVal) ? 0 : +strVal;
};

const getRealShape = el => {
  const defaultShape = {
    width: 0,
    height: 0
  };
  if (!el || typeof window === 'undefined') return defaultShape;
  const rect = el.getBoundingClientRect();
  const {
    width,
    height
  } = window.getComputedStyle(el);
  return {
    width: getCSSStyleVal(`${width}`, rect.width),
    height: getCSSStyleVal(`${height}`, rect.height)
  };
};

exports.getRealShape = getRealShape;

const useRealShape = ref => {
  const [state, setState] = (0, _react.useState)({
    width: 0,
    height: 0
  });

  const update = () => {
    const {
      width,
      height
    } = getRealShape(ref.current);
    setState({
      width,
      height
    });
  };

  (0, _react.useEffect)(() => update(), [ref.current]);
  return [state, update];
};

var _default = useRealShape;
exports.default = _default;